import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=5d1418a7&scoped=true"
import script from "./NewUserForm.vue?vue&type=script&lang=js"
export * from "./NewUserForm.vue?vue&type=script&lang=js"
import style0 from "./NewUserForm.vue?vue&type=style&index=0&id=5d1418a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1418a7",
  null
  
)

export default component.exports